import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import useId from '@indeed/ihl-use-id';
import { FORM_SIZES } from '../../constants/index.js';
import { parseFieldItems } from '../../utils/fields.js';
import { jsx } from '@emotion/react';
import { FormField } from '../FormField/FormField.js';
import { Radio } from '../Radio/Radio.js';
import '@indeed/ifl-css';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../../utils/transition.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Text/Text.js';
import '../Box/Box.js';
import '../Flex/Flex.js';

const RadioFormField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    items,
    name,
    ...props
  } = _ref;
  const {
    disabled,
    invalid,
    size
  } = props;
  const defaultId = `ifl-RadioFormField-${useId()}`;
  const id = props.id || defaultId;
  const autoGeneratedHelperTextId = `ifl-RadioFormField-helperTextId-${useId()}`;
  const helperTextId = props.helperTextId || (props.helperText ? autoGeneratedHelperTextId : undefined);
  const autoGeneratedErrorTextId = `ifl-RadioFormField-errorTextId-${useId()}`;
  const errorTextId = props.errorTextId || (props.errorText ? autoGeneratedErrorTextId : undefined);
  const parsedItems = parseFieldItems(items, id);
  return jsx(FormField, _extends({
    as: "fieldset",
    ref: ref,
    helperTextId: helperTextId,
    errorTextId: errorTextId,
    "aria-describedby": helperTextId
  }, props), parsedItems.map((radioProps, index) => jsx(Radio, _extends({
    key: `${radioProps.id}-${index}`,
    disabled: disabled,
    invalid: invalid,
    name: name,
    "aria-describedby": errorTextId,
    size: size
  }, radioProps))));
});
const RADIO_FORM_FIELD_SIZES = FORM_SIZES;
RadioFormField.displayName = "RadioFormField";

export { RADIO_FORM_FIELD_SIZES, RadioFormField };
